import React from "react";
import ZipCodesPageGen from "./generated/ZipCodesPageGen";
import zipCodesService from "../../../services/legacy/zipCodesService";

const SHOW_IN_GRID = new Set(["zipcode", "city", "county", "state", "country", "streetname"]);
const SHOW_IN_FILTER = new Set(["zipcode", "city", "county", "state", "country", "streetname"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const ZipCodesPage = () => {
  const service = zipCodesService;
  return <ZipCodesPageGen service={service} transformColumns={transformColumns} />;
};

export default ZipCodesPage;